
// import Kundali from '../../assets/Kundali.png'
// import Kundalimid from '../../assets/hand-3.png'
// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Service.scss';
// import { Link } from 'react-router-dom';

// // Import zodiac icons
// import aries from '../../assets/aries.png';
// import aquarius from '../../assets/aquarius.png';
// import cancer from '../../assets/cancer.png';
// import capricorn from '../../assets/capricorn.png';
// import gemini from '../../assets/gemini.png';
// import leo from '../../assets/leo.png';
// import libra from '../../assets/libra.png';
// import pisces from '../../assets/pisces.png';
// import sagittarius from '../../assets/sagittarius.png';
// import scorpio from '../../assets/scorpio.png';
// import taurus from '../../assets/taurus.png';
// import virgo from '../../assets/virgo.png';

// // Signs and festivals
// const signs = [
//   { name: 'Aries', icon: aries },
//   { name: 'Aquarius', icon: aquarius },
//   { name: 'Leo', icon: leo },
//   { name: 'Libra', icon: libra },
//   { name: 'Pisces', icon: pisces },
//   { name: 'Sagittarius', icon: sagittarius },
//   { name: 'Taurus', icon: taurus },
//   { name: 'Virgo', icon: virgo },
//   { name: 'Capricorn', icon: capricorn },
//   { name: 'Gemini', icon: gemini },
//   { name: 'Scorpio', icon: scorpio },
//   { name: 'Cancer', icon: cancer },
// ];


// const services = [
//   { name: 'Kundli (Birth Chart)', link: '/jyotish/kundali' },
//   { name: 'Horoscope Matching', link: '/jyotish/matchmaking' },
//   { name: 'Paid Services', link: '/#contact' },
//   { name: 'Numerology Calculator', link: '/numerology/luckynum' },
//   { name: 'Gochar Phal (Transit Report)', link: '/planets/planet-transit' },
//   { name: 'Baby Name Suggestion', link: '/jyotish/baby-name-finder' },
//   { name: "Today's Rahukaal", link: '/muhurat/rahu-kala' },
//   { name: 'Kaal Sarp Dosha', link: '/jyotish/kalsarpa-yoga' },
//   { name: 'Dasha Phal Analysis', link: '' }
// ];


//  const year = new Date().getFullYear();

// const festivalTabs = [
//   { label: 'Festival', path: '/festival/hindufest' },
//   //{ label: 'Holidays', path: '/holidays' },
// ];

// const dummyFestivalData = {
//   'Festival': ['Pongal', 'Mahashivratri', 'Holika Dahan ', 'Holi'],
//   'Holidays': ['Republic Day - Jan 26', 'Independence Day - Aug 15', 'Gandhi Jayanti - Oct 2'],
//   //'Calendar 2025': ['Amavasya - Jan 11', 'Full Moon - Feb 9', 'Eclipse - Mar 25']
// };

// const HoroscopeSection = () => {
//     const [radius, setRadius] = useState(getRadius());

//   // helper function for radius
//   function getRadius() {
//     if (window.innerWidth <= 480) return 140;
//     if (window.innerWidth <= 768) return 180;
//     if (window.innerWidth <= 1024) return 300;
//     if (window.innerWidth <= 1270) return 300;
//     return 400; // default desktop
//   }

//   useEffect(() => {
//     const handleResize = () => {
//       setRadius(getRadius());
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);


//   // Center image size tied to radius
//   const centerImgSize = radius * 0.98; // adjust ratio as needed

//   const [selectedTab, setSelectedTab] = useState('Daily');
//   const [selectedSign, setSelectedSign] = useState('Aries');
//   const [showFull, setShowFull] = useState(false);
//   const [selectedFestivalTab, setSelectedFestivalTab] = useState('Festival');
//   const [horoscope, setHoroscope] = useState('');
//   const [date, setDate] = useState('');

 

//   useEffect(() => {
//     const fetchHoroscope = async () => {
//       try {
//         const res = await axios.get(
//           `https://core-239315041538.europe-west1.run.app//api/v1/get-horoscope/daily?sign=${selectedSign}&day=TODAY`
//         );
//         setHoroscope(res.data.data.horoscope_data);
//         setDate(res.data.data.date);
//       } catch (err) {
//         console.error('Failed to fetch horoscope:', err);
//         setHoroscope('Horoscope not available.');
//       }
//     };

//     // Only fetch for "Daily" tab as API only supports that
//     if (selectedTab === 'Daily') {
//       fetchHoroscope();
//     } else {
//       setHoroscope('Only daily horoscope is available currently.');
//     }
//   }, [selectedSign, selectedTab]);

//   const isLong = horoscope.length > 200;
//   const visibleText = showFull || !isLong ? horoscope : `${horoscope.substring(0, 200)}...`;

//   return (
//     <div className="services-section" id='services'>
//       <div className="services-header">
//         <strong>SERVICES</strong>
//         <span>| Our Services</span>
//       </div>

//       {/* <div className="services-grid">                  this section is before it became circular
//        {services.map((item, index) => (
//           <Link to={item.link} key={index} className="service-card">
//             <div className="icon-placeholder">
//               <img src={Kundali} alt="err" />
//             </div>
//             <span>{item.name}</span>
//           </Link>
//         ))}
//       </div> */}

//       <div className="services-grid">
//           {/* Center logo/image */}
//           <div className="center-content">
//             <img 
//             src={Kundalimid} 
//             alt="Center Logo" 
//             style={{
//             width: centerImgSize,
//             height: centerImgSize,
//           }}
//             />
//           </div>

//         {services.map((item, index) => {
//           const angle = (360 / services.length) * index; // evenly spaced
//           const x = Math.cos((angle * Math.PI) / 180) * radius;
//           const y = Math.sin((angle * Math.PI) / 180) * radius;

//           return (
//             <div
//               className="service-wrapper"  // this is needed for circular position only
//               key={index}
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "40%",
//                 transform: `translate(${x}px, ${y}px)`,
//               }}
//             >
//               <Link to={item.link} className="service-card">
//                 <div className="icon-placeholder">
//                   <img src={Kundali} alt="err" />
//                 </div>
//                 <span>{item.name}</span>
//               </Link>
//             </div>
//           );
//         })}
//       </div>
    


//       {/* <div className="horoscope-festival-container">
//         <div className="horoscope-box"id='todayHoroscope'>
//           <div className="tabs">
//             {['Daily', 'Weekly', 'Weekly Love', 'Monthly', 'Yearly'].map((label, index) => (
//               <div
//                 className={`tab ${selectedTab === label ? 'active' : ''}`}
//                 key={index}
//                 onClick={() => {
//                   setSelectedTab(label);
//                   setShowFull(false);
//                 }}
//               >
//                 {label}
//               </div>
//             ))}
//           </div>

//           <div className="horoscope-symbol">
//             {signs.map((sign, i) => (
//               <img
//                 key={i}
//                 src={sign.icon}
//                 alt={sign.name}
//                 onClick={() => {
//                   setSelectedSign(sign.name);
//                   setShowFull(false);
//                 }}
//                 className={selectedSign === sign.name ? 'active' : ''}
//               />
//             ))}
//           </div>

//           <div className="horoscope-details">
//             <h4>{selectedSign} {selectedTab} Horoscope</h4>
//             <p className="date">{date}</p>
//             <p className="description">
//               {visibleText}
//               {isLong && (
//                 <span
//                   className="read-more"
//                   onClick={() => setShowFull(!showFull)}
//                   style={{ color: 'orange', cursor: 'pointer' }}
//                 >
//                   {showFull ? ' Show Less' : ' Read More'}
//                 </span>
//               )}
//             </p>
//           </div>
//         </div>

//         <div className="festival-box">
//           <div className="festival-header">
//             {festivalTabs?.map((tab, idx) => (
//                 <Link
//                   key={idx}
//                   to={tab.path}
//                   className={`festival-tab-link ${selectedFestivalTab === tab.label ? 'active-tab' : ''}`}
//                   onClick={() => setSelectedFestivalTab(tab.label)}
//                 >
//                   {tab.label} {year}
//                 </Link>
//             ))}
//           </div>
//           <ul>
//             {dummyFestivalData[selectedFestivalTab].map((festival, i) => (
//               <li key={i}>{festival} {year}</li>
//             ))}
//           </ul>
//         </div>
//       </div> */}
//     </div>
//   );
// };

// export default HoroscopeSection;

import Kundali from '../../assets/Kundali.png';
import Kundalimid from '../../assets/hand-3.png';
import { useState, useEffect } from 'react';
import axios from 'axios';
import './Service.scss';
import { Link } from 'react-router-dom';

// Zodiac icons (used in commented code only – keep removed)
import aries from '../../assets/aries.png';
import aquarius from '../../assets/aquarius.png';
import cancer from '../../assets/cancer.png';
import capricorn from '../../assets/capricorn.png';
import gemini from '../../assets/gemini.png';
import leo from '../../assets/leo.png';
import libra from '../../assets/libra.png';
import pisces from '../../assets/pisces.png';
import sagittarius from '../../assets/sagittarius.png';
import scorpio from '../../assets/scorpio.png';
import taurus from '../../assets/taurus.png';
import virgo from '../../assets/virgo.png';

/* ================= SERVICES ================= */

const services = [
  { name: 'Kundli (Birth Chart)', link: '/jyotish/kundali' },
  { name: 'Horoscope Matching', link: '/jyotish/matchmaking' },
  { name: 'Paid Services', link: '/#contact' },
  { name: 'Numerology Calculator', link: '/numerology/luckynum' },
  { name: 'Gochar Phal (Transit Report)', link: '/planets/planet-transit' },
  { name: 'Baby Name Suggestion', link: '/jyotish/baby-name-finder' },
  { name: "Today's Rahukaal", link: '/muhurat/rahu-kala' },
  { name: 'Kaal Sarp Dosha', link: '/jyotish/kalsarpa-yoga' },
  { name: 'Dasha Phal Analysis', link: '' }
];

const HoroscopeSection = () => {
  /* ================= RESPONSIVE RADIUS ================= */
  const getRadius = () => {
    if (window.innerWidth <= 480) return 140;
    if (window.innerWidth <= 768) return 180;
    if (window.innerWidth <= 1024) return 300;
    if (window.innerWidth <= 1270) return 300;
    return 400;
  };

  const [radius, setRadius] = useState(getRadius());

  useEffect(() => {
    const handleResize = () => setRadius(getRadius());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const centerImgSize = radius * 0.98;

  /* ================= HOROSCOPE STATE (MINIMAL) ================= */
  const [selectedTab] = useState('Daily');
  const [selectedSign] = useState('Aries');
  const [horoscope, setHoroscope] = useState('');

  useEffect(() => {
    const fetchHoroscope = async () => {
      try {
        const res = await axios.get(
          `https://core-239315041538.europe-west1.run.app/api/v1/get-horoscope/daily?sign=${selectedSign}&day=TODAY`
        );
        setHoroscope(res.data.data.horoscope_data);
      } catch (err) {
        console.error('Failed to fetch horoscope:', err);
        setHoroscope('Horoscope not available.');
      }
    };

    if (selectedTab === 'Daily') {
      fetchHoroscope();
    }
  }, [selectedSign, selectedTab]);

  /* ================= RENDER ================= */

  return (
    <div className="services-section" id="services">
      <div className="services-header">
        <strong>SERVICES</strong>
        <span>| Our Services</span>
      </div>

      <div className="services-grid">
        {/* Center image */}
        <div className="center-content">
          <img
            src={Kundalimid}
            alt="Center"
            style={{ width: centerImgSize, height: centerImgSize }}
          />
        </div>

        {services.map((item, index) => {
          const angle = (360 / services.length) * index;
          const x = Math.cos((angle * Math.PI) / 180) * radius;
          const y = Math.sin((angle * Math.PI) / 180) * radius;

          return (
            <div
              className="service-wrapper"
              key={index}
              style={{
                position: 'absolute',
                top: '50%',
                left: '40%',
                transform: `translate(${x}px, ${y}px)`
              }}
            >
              <Link to={item.link} className="service-card">
                <div className="icon-placeholder">
                  <img src={Kundali} alt={item.name} />
                </div>
                <span>{item.name}</span>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HoroscopeSection;
